/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description No Data Found
 */
// TODO
import { Result, ResultProps } from 'antd';

import { AppButton } from 'components/widgets/button';
import NO_DATA_FOUND from 'assets/no-data.svg';
import { getAppLogo } from 'utils/common';

const LOGO = <img width={300} src={getAppLogo()} alt='veritable-logo' />;

type IResultType =
	| 'success'
	| 'info'
	| 'warning'
	| 'error'
	| 'unauthorized'
	| 'serverError'
	| 'noData'
	| 'pageNotFound'
	| 'underMaintenance'
	| 'logout'
	| 'viewPortBlocker'
	| 'appAccessDenied'
	| 'onboardingFailure';

const RESULT_TYPES: Record<IResultType, ResultProps> = {
	success: {
		status: 'success',
		title: 'Success',
		subTitle: 'Success',
	},
	info: {
		status: 'info',
		title: 'Info',
		subTitle: 'Info',
	},
	warning: {
		status: 'warning',
		title: 'Warning',
		subTitle: 'Warning',
	},
	error: {
		status: 'error',
		title: 'Error',
		subTitle: 'Sorry, something went wrong.',
		extra: [<AppButton.Home type='default' key='home' />, <AppButton.Reload key='reload' />],
	},
	unauthorized: {
		status: '403',
		title: 'Unauthorized',
		subTitle: 'Sorry, you are not authorized to access this page. Please contact your admin.',
		extra: [<AppButton.Home type='default' key='home' />, <AppButton.Reload key='reload' />],
	},
	pageNotFound: {
		status: '404',
		title: 'Page Not Found',
		subTitle: 'Sorry, the page you are looking for does not exist.',
		extra: [<AppButton.Home type='default' key='home' />, <AppButton.Reload key='reload' />],
	},
	serverError: {
		status: '500',
		title: 'Server Error',
		subTitle: 'Sorry, something went wrong on the server.',
		extra: [<AppButton.Home type='default' key='home' />, <AppButton.Reload key='reload' />],
	},
	noData: {
		title: 'No Data found',
		icon: <img src={NO_DATA_FOUND} alt='no-data' />,
		extra: [<AppButton.Home type='default' key='home' />, <AppButton.Reload key='reload' />],
	},
	underMaintenance: {
		title: 'Veritable Under Maintenance',
		subTitle: 'We will be back soon',
		icon: LOGO,
		extra: <AppButton.Reload />,
	},
	logout: {
		title: 'You have successfully logged out of Veritable',
		icon: LOGO,
		extra: [
			<span key='login-again'>
				<a href={globalThis.location.origin}>Click here</a> to login again
			</span>,
		],
	},
	viewPortBlocker: {
		title: 'Oops!',
		subTitle: "We don't support mobile devices yet. Please use a desktop or laptop to access the app.",
		icon: LOGO,
		extra: <AppButton.Reload />,
	},
	appAccessDenied: {
		title: 'You do not have the permission to view this page',
		subTitle: 'Please contact your admin',
		icon: LOGO,
		extra: <AppButton.Logout />,
	},
	onboardingFailure: {
		status: 'error',
		title: 'Error while onboarding.',
		subTitle: 'Please reload & try again.',
		extra: [<AppButton.Reload key='reload' />],
	},
};

// TODO : add soft reload

/**
 * NoDataFound
 */
const AppResult: React.FC<ResultProps> = (props) => {
	return <Result {...props} />;
};

export { RESULT_TYPES, type IResultType };
export default AppResult;
